import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { newSeasonFilterStyle } from "../../../services/utils";
import ReactSelect, { components } from "react-select";
import {
  setEventStatsSaison
} from "../../../actions/actions/eventStats";
import { getSeasonsValues } from "../../../actions/thunks/eventStats";
import _ from 'lodash';

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const SaisonFilter = ({
  eventStatsFilter,
  seasons: seasonsData,
  auth,
  setEventStatsSaison,
  getSeasonsValues
}) => {

  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    getSeasons();
  }, [eventStatsFilter.year]);

  useEffect(() => {
    if (seasonsData && seasonsData.items) {
      let items = seasonsData.items;
      let newSeasons = items.map(part => {
        let label = '';

        if (part.name_fr) {
          label = part.name_fr;
        } else if (part.name_en) {
          label = part.name_en;
        } else if (part.name_nl) {
          label = part.name_nl;
        }

        return { label, value: part.id };
      });

      newSeasons.unshift({ value: 'ALL', label: 'TOUTES LES FORMATS' });
      newSeasons.push({ value: 'NONE', label: 'AUCUNE FORMAT' });

      setSeasons(newSeasons);
    }
  }, [seasonsData && seasonsData.items]);

  const getSeasons = () => {
    let params = {};

    if (auth && auth.currentClient) {
  params.issuerId = auth.currentClient.id;
}

    getSeasonsValues(params);
  }

  const handleSelectChange = (value) => {
    setEventStatsSaison(value.value);
  }

    return (
      <ReactSelect
        onChange={handleSelectChange}
        styles={newSeasonFilterStyle()}
        defaultValue={{ value: 'ALL', label: 'TOUTES LES FORMATS' }}
        options={seasons}
        components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
      />
    );
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  seasons: state.seasons,
  auth: state.auth
});

const mapDispatchToProps = {
  setEventStatsSaison,
  getSeasonsValues
};

export default connect(mapStateToProps, mapDispatchToProps)(SaisonFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/SaisonFilter.js